import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["key"];
import React from "react";
import Breadcrumb from "./components/Breadcrumb";
import { BaseBreadcrumbsContainer } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Breadcrumbs(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "breadcrumb",
    children: /*#__PURE__*/_jsx(BaseBreadcrumbsContainer, {
      children: items.map(function (item, index) {
        var isLastItem = index === items.length - 1;
        // Drops a `key` an untyped consumer may have set; the explicit key wins anyway.
        var _ref2 = item,
          key = _ref2.key,
          rest = _objectWithoutProperties(_ref2, _excluded);
        return /*#__PURE__*/_jsx(Breadcrumb, _extends({}, rest, {
          isLastItem: isLastItem
        }), "".concat(item.href, "-").concat(item.text));
      })
    })
  });
}
export default Breadcrumbs;